/*
 * Kalira — code promo appliqué directement sur le panier (drawer + page /cart)
 * Applique / retire via POST /cart/update.js {discount:"CODE"} puis re-render
 * les sections panier via l'API Section Rendering (?sections=...).
 */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function post(discount) {
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: discount }),
    }).then(function (r) {
      return r.json();
    });
  }

  function codeApplied(cart, code) {
    var wanted = code.trim().toUpperCase();
    return (cart.discount_codes || []).some(function (c) {
      return c.applicable && (c.code || '').toUpperCase() === wanted;
    });
  }

  // Recharge le HTML des sections panier présentes sur la page et remplace le DOM.
  function reRenderCart() {
    var ids = [];
    if (document.querySelector('cart-drawer')) ids.push('cart-drawer');
    var footer = document.getElementById('main-cart-footer');
    var items = document.getElementById('main-cart-items');
    if (footer && footer.dataset.id) ids.push(footer.dataset.id);
    if (items && items.dataset.id) ids.push(items.dataset.id);
    ids.push('cart-icon-bubble');

    var url = window.location.pathname + '?sections=' + ids.filter(uniq).join(',');
    return fetch(url)
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        swap(data['cart-drawer'], '#CartDrawer', document.querySelector('#CartDrawer'));
        if (footer && footer.dataset.id) swap(data[footer.dataset.id], '#main-cart-footer', footer);
        if (items && items.dataset.id) swap(data[items.dataset.id], '#main-cart-items', items);
        swapBubble(data['cart-icon-bubble']);
      });
  }

  function uniq(v, i, a) {
    return a.indexOf(v) === i;
  }

  function swap(html, selector, current) {
    if (!html || !current) return;
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    if (fresh) current.innerHTML = fresh.innerHTML;
  }

  function swapBubble(html) {
    if (!html) return;
    var cur = document.getElementById('cart-icon-bubble');
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (cur && fresh) cur.innerHTML = fresh.innerHTML;
  }

  function setMessage(scope, text, state) {
    var el = scope && scope.querySelector('[data-kdisc-message]');
    if (!el) return;
    el.textContent = text || '';
    el.setAttribute('data-state', state || '');
  }

  function apply(scope) {
    var input = scope.querySelector('[data-kdisc-input]');
    if (!input) return;
    var code = input.value.trim();
    if (!code) {
      setMessage(scope, 'Veuillez entrer un code promo.', 'error');
      return;
    }
    if (scope.classList.contains('is-loading')) return;
    scope.classList.add('is-loading');
    setMessage(scope, '', '');

    post(code)
      .then(function (cart) {
        if (codeApplied(cart, code)) {
          return reRenderCart();
        }
        scope.classList.remove('is-loading');
        setMessage(scope, 'Code invalide ou non applicable à votre panier.', 'error');
      })
      .catch(function () {
        scope.classList.remove('is-loading');
        setMessage(scope, 'Une erreur est survenue, veuillez réessayer.', 'error');
      });
  }

  function remove() {
    post('').then(reRenderCart).catch(function () {});
  }

  function closeDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.close === 'function') {
      drawer.close();
    } else {
      window.location.href = ROOT;
    }
  }

  document.addEventListener('click', function (e) {
    var applyBtn = e.target.closest('[data-kdisc-apply]');
    if (applyBtn) {
      e.preventDefault();
      var scope = applyBtn.closest('[data-kdisc]');
      if (scope) apply(scope);
      return;
    }
    if (e.target.closest('[data-kdisc-remove]')) {
      e.preventDefault();
      remove();
      return;
    }
    if (e.target.closest('[data-kdisc-continue]')) {
      e.preventDefault();
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('[data-kdisc-input]');
    if (!input) return;
    e.preventDefault();
    var scope = input.closest('[data-kdisc]');
    if (scope) apply(scope);
  });
})();
